import { Typography, Tooltip } from '@mui/material';
import React from 'react';
import { useAppState } from 'store/Provider';
import HelpMenuListVideos from 'types/entities/HelpMenuVideos';

const TitleCell = React.memo((row: HelpMenuListVideos) => {
  const { dispatch } = useAppState();

  return (
    <Tooltip arrow title={row.title ?? ''}>
      <Typography noWrap variant="body2">
        {row?.title}
      </Typography>
    </Tooltip>
  );
});

export default TitleCell;
